import React, { useEffect, useState } from 'react'
import { useAuthStore } from 'src/hooks/auth'
import useReduxState from 'src/hooks/useReduxState'
import Helper from 'src/support/Helper'
import ReusableDiv from 'src/support/ReusableDiv'
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useSelector } from "react-redux";

const StepShippingMethod = () => {
    const [checkOutStepStatus, setCheckoutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [selectedCarrier, setSelectedCarrier] = useReduxState('', 'setSelectedCarrier');
    const [carrierSelectionError, setCarrierSelectionError] = useState(false);
    const [selectedShippingMethod, setSelectedShippingMethod] = useReduxState('AvnetOption', "setSelectedShippingMethod");
    const [carrierStepComplete, setCarrierStepComplete] = useReduxState('', "setCarrierStepComplete");
    const [{ CUSTOMER_INFORMATION }, { }, { }] = useAuthStore();
    const [isEdit, setIsEdit] = useState(false);

    // useEffect(() => {
    //     if (CUSTOMER_INFORMATION?.data?.carrier.length > 0) {
    //         if (CUSTOMER_INFORMATION?.data?.carrier.length === 1) {
    //             setSelectedCarrier(CUSTOMER_INFORMATION?.data?.carrier[0]?.carrier_id)
    //         }
    //         setSelectedShippingMethod('CarrierAcct')
    //     }
    //     else {
    //         setSelectedShippingMethod('AvnetOption')
    //     }
    // }, [CUSTOMER_INFORMATION])

    const handleSubmit = () => {
        // setCarrierSelectionError(false)
        // if (selectedShippingMethod === 'CarrierAcct' &&
        //     !Helper.valueIsNotNull(selectedCarrier)) {
        //     setCarrierSelectionError(true);
        //     return false;
        // }        // Validate Carrier
        setIsEdit(false);
        setCarrierStepComplete(Helper.UUID())
        checkOutStep2();
        setCheckoutStepStatus('step3')
    }

    //By Ramya Kannan [Checkout-step2 ]
    const CART_DATA = useSelector((state) => state.entities.Cart.CART_DATA);
    function checkOutStep2(){
        localStorage.setItem("adobeEventType","checkOut");
        let stepType = "checkoutStep2";
        let prodDetails = CART_DATA;
        if(Object.keys(prodDetails).length){
        HelperAdobeEvent.trackingAdobeEvent({prodDetails,stepType});

        }
    }

    const onShippingMethodChange = (value) => {
        // setCarrierSelectionError(false)
        if (value === 'AvnetOption') {
            setSelectedCarrier('')
        }
        // setSelectedShippingMethod(value);
    }
    return (
        <div>
            <div className={"shipping-method steps-inner mb-3 " + (((checkOutStepStatus.toLowerCase() === 'step3') && !isEdit) ? 'active completed' : (checkOutStepStatus.toLowerCase() != 'step1' && 'active'))}>
                <div className="checkout-titles d-flex justify-content-between ps-0">
                    {ReusableDiv.checkoutStepTitle("2. Shipping Method")}
                    <a onClick={() => setIsEdit(true)}>Change</a>
                </div>
                <div className="checkbox-steps-content">
                    <div className="step-complete-hide">
                        <div className="shipping-method-detail checkbox-steps-content p-0">
                            <div className="bs5 row">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <h3 className="mt-0">SHIPPING METHOD OPTIONS:</h3>
                                    <div className="form-check mb-2">
                                        {/* {CUSTOMER_INFORMATION?.data?.carrier.length > 0 &&
                                            <>
                                                <div className=' mb-3'>
                                                    <input className="form-check-input" type="radio" name="shipping-method-radio" id="myCarrierAcct"
                                                        checked={selectedShippingMethod === 'CarrierAcct'}
                                                        onChange={(e) => {
                                                            onShippingMethodChange('CarrierAcct')
                                                        }} />
                                                    <label className="form-check-label " for="myCarrierAcct"> <strong className='text-darkgreen'> Use My Carrier Account </strong></label>

                                                    {selectedShippingMethod === 'CarrierAcct' &&
                                                        <div className=' mt-2 pb-3 border-bottom carrier-account-number'>
                                                            <p className='mb-1'>Carrier Account Number*</p>
                                                            <div className='selectbox'>
                                                                <select className={`form-control  ${carrierSelectionError ? ' error' : ''}`} aria-label="carrier" id="carrier" name="carrier"
                                                                    onChange={({ target: { value } }) => { setCarrierSelectionError(false); setSelectedCarrier(value) }}
                                                                >
                                                                    <option value="">Select a Carrier Account Number</option>
                                                                    {CUSTOMER_INFORMATION?.data?.carrier?.length > 0 && CUSTOMER_INFORMATION?.data?.carrier?.map((v, i) => (
                                                                        <option key={i} value={v?.carrier_id} selected={selectedCarrier === v?.carrier_id ? 'selected' : ''}>{v?.carrier_id}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {carrierSelectionError && <p className="error">Please select a carrier account number.</p>}
                                                        </div>
                                                    }
                                                </div>
                                            </>
                                        } */}
                                        <input className="form-check-input" type="radio" name="shipping-method-radio" id="avnetOption"
                                            checked={selectedShippingMethod === 'AvnetOption'}
                                            onChange={(e) => {
                                                onShippingMethodChange('AvnetOption')
                                            }} />
                                        <label className="form-check-label" for="avnetOption"> Use Avnet's Carrier Options </label>

                                        {selectedShippingMethod === 'AvnetOption' &&
                                            <>{ReusableDiv.AvnetCarrierOptionHeader()}</>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="step-complete-show">
                        <h3 className="mt-0 mb-3">SHIPPING METHOD OPTIONS:</h3>
                        <div className="bs5 row">
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                {selectedCarrier &&
                                    <>
                                        <b className='font-13 font-arial'>Carrier Account Number</b>
                                        <p className="mb-2 font-13 font-arial">{selectedCarrier}</p>
                                    </>
                                }
                                {!selectedCarrier &&
                                    <>
                                        <b className='font-13 font-arial mb-1 d-block'> {`${!((checkOutStepStatus.toLowerCase() === 'step3') && !isEdit) ? 'Use' : ''} Avnet's Carrier Options`} </b>
                                        {ReusableDiv.AvnetCarrierOptionHeader()}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    {console.log(checkOutStepStatus)}
                    {(checkOutStepStatus.toLowerCase() === 'step2' || isEdit) &&
                        <div className='form-check mb-2'>
                            <button type="button" className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto"
                                form="hook-form" onClick={() => handleSubmit()}>Use this shipping method</button>
                        </div>
                    }
                </div>

            </div>
        </div>
    )
}

export default StepShippingMethod
